import React from 'react';

import { Button, Flex, Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { IError } from '@app/models/error';
import { translateApiError } from '@app/services/apiErrors';

import { OrderNumberLink } from './components/OrderNumberLink';

interface IProps {
  error?: IError;
  onClose: () => void;
}

export const UnfinishedOrdersModal: React.FC<IProps> = ({ error, onClose }) => {
  const warehousesT = useTranslation(NSKeys.warehouses);
  const validationT = useTranslation(NSKeys.validation);

  return (
    <Modal
      open={!!error}
      title={error ? translateApiError(error, validationT.t) : undefined}
      onCancel={onClose}
      footer={
        <Button type="primary" onClick={onClose}>
          {warehousesT.t('unfinishedOrders.close')}
        </Button>
      }
      destroyOnHidden
    >
      <Flex vertical gap={12}>
        <Typography.Text>{warehousesT.t('unfinishedOrders.orders')}</Typography.Text>
        <Flex wrap gap={12} style={{ maxHeight: 240, overflowY: 'auto' }}>
          {(error?.meta?.orders || []).map((order) => (
            <OrderNumberLink key={order.uid} order={order} />
          ))}
        </Flex>
        <Typography.Text type="secondary">{warehousesT.t('unfinishedOrders.hint')}</Typography.Text>
      </Flex>
    </Modal>
  );
};
